import {createSvgIcon} from '../create-svg-icon';

export const ViewCompactIcon = createSvgIcon(
  <path d="M3 5v14h19V5H3zm2 2h15v4H5V7zm0 10v-4h4v4H5zm6 0v-4h9v4h-9z" />
, 'ViewCompactOutlined');
